package kz.dentalcrm.app.screens.quick_replies.list

import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply
import kz.dentalcrm.app.domain.QuickRepliesRepository
import kz.dentalcrm.app.screens.quick_replies.list.mvi.QuickRepliesViewEvent
import kz.dentalcrm.app.screens.quick_replies.list.mvi.QuickRepliesViewSideEffect
import kz.dentalcrm.app.screens.quick_replies.list.mvi.QuickRepliesViewState
import org.koin.core.component.inject

class QuickRepliesViewModel :
    BaseStateViewModel<QuickRepliesViewEvent, QuickRepliesViewState, QuickRepliesViewSideEffect>() {

    private val quickRepliesRepository: QuickRepliesRepository by inject()

    override fun setInitialState() = QuickRepliesViewState()

    private var currentPage: Int = 1
    private var _isLastPage: Boolean = false

    private val quickRepliesList = mutableListOf<QuickReply>()

    override fun handleEvents(event: QuickRepliesViewEvent) {
        when (event) {
            is QuickRepliesViewEvent.SearchQuickReply -> {
                _isLastPage = false
                currentPage = 1
                quickRepliesList.clear()
                setState {
                    copy(
                        search = event.search,
                        quickReplies = persistentListOf()
                    )
                }
                loadQuickReplies(delayMillis = 300L)
            }
            QuickRepliesViewEvent.LoadMore -> {
                loadQuickReplies()
            }
            QuickRepliesViewEvent.Reload -> {
                _isLastPage = false
                currentPage = 1
                quickRepliesList.clear()
                setState {
                    copy(quickReplies = persistentListOf())
                }
                loadQuickReplies(delayMillis = 1500L)
            }
            is QuickRepliesViewEvent.EditQuickReply -> {
                setEffect {
                    QuickRepliesViewSideEffect.ShowEditQuickReply(quickReply = event.quickReply)
                }
            }
            is QuickRepliesViewEvent.DeleteQuickReply -> {
                quickRepliesList.removeAll { it.id == event.id }
                setState {
                    copy(quickReplies = quickRepliesList.toPersistentList())
                }
            }
        }
    }

    private fun loadQuickReplies(delayMillis: Long = 0L) {
        if (_isLastPage) return
        setState {
            copy(screenState = QuickRepliesViewState.ScreenState.Loading)
        }
        launch(Dispatchers.Default) {
            delay(delayMillis)
            quickRepliesRepository.getQuickReplies(page = currentPage).stateHandle(
                onError = { _, message ->
                    setState {
                        copy(screenState = QuickRepliesViewState.ScreenState.Error(text = message))
                    }
                },
                onFailure = {
                    setState {
                        copy(screenState = QuickRepliesViewState.ScreenState.Error(text = "Произошла неожиданная ошибка"))
                    }
                },
                onSuccess = { data ->
                    quickRepliesList.addAll(data ?: emptyList())
                    currentPage++
                    setState {
                        copy(
                            quickReplies = quickRepliesList.toPersistentList(),
                            screenState = QuickRepliesViewState.ScreenState.Idle
                        )
                    }
                    _isLastPage = (data?.size ?: 0) < PAGE_SIZE
                }
            )
        }
    }

    init {
        loadQuickReplies()
    }

    companion object {
        private const val PAGE_SIZE = 10
    }
}
